import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class HasInvalidPasswordGuard implements CanActivate {
	constructor(
		private store: Store<any>,
		private router: Router
	) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
		if (localStorage && localStorage.getItem('passLength') && Number(localStorage.getItem('passLength')) < 12) {
			return this.router.navigate(['/account/settings/password/edit'], { queryParams: { forceReset: 1 } });
		}
		return of(true);
	}
}
